export default __webpack_public_path__ + "static/media/dm.94ca3ef0.jpg";